module.exports = __webpack_public_path__ + "static/media/heroImage2.a3ff169a.png";